export const uiSchemaTelefonosForm = {
  type: "VerticalLayout",
  elements: [
    {
      type: "VerticalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/id",
          options: {
            readonly: true
          }
        },
        {
          type: "Control",
          scope: "#/properties/selectedTipoTelefono",
        },
        {
          type: "Control",
          scope: "#/properties/numero",
        },
      ],
    },
  ],
};